var exports = {
  "Y3": "MessageSearchBar.module__anchor___SGNSam",
  "sM": "MessageSearchBar.module__srOnly___SGNSam",
  "Kf": "MessageSearchBar.module__inputContainer___SGNSam",
  "D": "MessageSearchBar.module__inputContainerOnCall___SGNSam",
  "qc": "MessageSearchBar.module__searchIcon___SGNSam",
  "MS": "MessageSearchBar.module__scopeBadge___SGNSam",
  "xJ": "MessageSearchBar.module__scopeButton___SGNSam",
  "mt": "MessageSearchBar.module__clearButton___SGNSam",
  "It": "MessageSearchBar.module__optionMetaIcon___SGNSam",
  "jC": "MessageSearchBar.module__popoutContainer___SGNSam",
  "IF": "MessageSearchBar.module__popoutInner___SGNSam",
  "p_": "MessageSearchBar.module__list___SGNSam",
  "uK": "MessageSearchBar.module__option___SGNSam",
  "wA": "MessageSearchBar.module__optionActive___SGNSam",
  "LO": "MessageSearchBar.module__optionKeyboardFocus___SGNSam",
  "ed": "MessageSearchBar.module__optionLabel___SGNSam",
  "bZ": "MessageSearchBar.module__optionContent___SGNSam",
  "m6": "MessageSearchBar.module__valueOptionContent___SGNSam",
  "Cs": "MessageSearchBar.module__valueOptionText___SGNSam",
  "rU": "MessageSearchBar.module__valueOptionTitle___SGNSam",
  "i": "MessageSearchBar.module__valueOptionDefault___SGNSam",
  "re": "MessageSearchBar.module__optionText___SGNSam",
  "Ee": "MessageSearchBar.module__optionTitle___SGNSam",
  "UH": "MessageSearchBar.module__historyOptionTitle___SGNSam",
  "q3": "MessageSearchBar.module__optionDescription___SGNSam",
  "Tp": "MessageSearchBar.module__optionMetaIconInactive___SGNSam",
  "ZF": "MessageSearchBar.module__userRow___SGNSam",
  "WG": "MessageSearchBar.module__channelRow___SGNSam",
  "HA": "MessageSearchBar.module__channelName___SGNSam",
  "a1": "MessageSearchBar.module__userTag___SGNSam",
  "p": "MessageSearchBar.module__channelIcon___SGNSam",
  "nM": "MessageSearchBar.module__searchFilter___SGNSam",
  "JH": "MessageSearchBar.module__popoutSection___SGNSam",
  "GH": "MessageSearchBar.module__popoutSectionHeader___SGNSam",
  "Uu": "MessageSearchBar.module__flex___SGNSam",
  "MR": "MessageSearchBar.module__flexCol___SGNSam",
  "y9": "MessageSearchBar.module__itemsCenter___SGNSam",
  "ex": "MessageSearchBar.module__gap1___SGNSam",
  "l$": "MessageSearchBar.module__gap2___SGNSam",
  "mE": "MessageSearchBar.module__minW0___SGNSam",
  "ZT": "MessageSearchBar.module__overflowHidden___SGNSam",
};

module.exports = exports;
